export const user = (state = {}, action) => {
  switch (action.type) {
    case 'LOG_IN_USER':
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

export default {
  user
};



// WEBPACK FOOTER //
// ./src/components/Login/reducers.js